import {addLiveEventListener} from './utils';

export default class Price {
	constructor(app) {
		this.app = app;
		const self = this;

		self.requestDiscounts()
		addLiveEventListener('load', '.js-section-container', function () {
			console.debug('section loaded', this); // TODO: test
			self.requestDiscounts();
		})
	}

	requestDiscounts() {
		const self = this;

		fetch('/discount/getActiveDiscounts')
			.then(req => req.json())
			.then(res => self.loadDicounts(res));
	}

	loadDicounts(data) {
		const self = this;

		if (!data && !data.byProductType && !data.byProductKey) {
			console.debug('No discounts');
			return; //TODO: Is this okay here?
		}
		const {byProductType, byProductKey} = data;

		document.querySelectorAll('.js-price-box').forEach(function (v, k) { //each priceTag
			let {subtype, prodkeys} = v.dataset;
			let priceNode = v.querySelector('.js-price-value')
			if (!priceNode) {
				console.warn('No price value element');
				return;
			}
			const listprice = parseFloat(priceNode.dataset.price);
			const rrpdiscounted = (priceNode.dataset.rrpdiscounted === 'True');
			let discountprice = listprice;

			if (rrpdiscounted !== true) {
				prodkeys = (prodkeys ?? '').split(',');
				prodkeys.forEach(prodkey => {
					if (prodkey && prodkey in byProductKey) {// TODO: test
						const {prate} = byProductKey[prodkey];
						let newprice = self.round(listprice * (1 - prate / 100), 2);
						if (newprice < discountprice) {
							discountprice = newprice;
						}
					}
				});

				if (subtype && subtype in byProductType) {
					const {prate} = byProductType[subtype];
					let newprice = self.round(listprice * (1 - prate / 100), 2);
					if (newprice < discountprice) {
						discountprice = newprice;
					}
				}
			}

			if(discountprice !== listprice)
				self.updateprice(v, discountprice, listprice);
		})
	}

	updateprice(target, discount, listprice) {
		const self = this;
		let savingNode, uvpNode;

		target.querySelector('.js-price-value').innerHTML = `${self.format(discount)} <span class="euro-sign">&euro;</span>`;
		if ((savingNode = target.querySelector('.js-price-saving')) !== null)
			savingNode.innerHTML = (`${Math.round((100 / listprice * discount)-100)} <span class="euro-sign">%</span>`);
		if ((uvpNode = target.querySelector('.js-price-uvp')) !== null) {
			uvpNode.innerHTML = `${self.format(listprice)} <span class="euro-sign">&euro;</span>`;
			uvpNode.classList.toggle('is-hidden', discount >= listprice);
		}
	}

	round(value, dec = 0) {
		value = parseFloat(value);
		if (!value) {
			return 0;
		}
		dec = parseInt(dec);

		const factor = Math.pow(10, dec);
		return Math.round(value * factor) / factor;
	}

	format(val) {
		return parseFloat(val).toLocaleString('de-DE', {
			minimumFractionDigits: 2
		});
	}
}
